<template>
  <div class="uk-position-relative uk-width-1-1">
    <input type="text"
      placeholder="Телефон:"
      :value="phoneMask(value)" class="cl-wh uk-input fs14 fs16@m" @input="$emit('input', $event.target.value)"
      :class="{'uk-form-large': size === 'large'}"
    >
  </div>
</template>

<script>
  export default {
    props: ['value', 'size'],

    methods: {
      phoneMask(val) {
        let phoneRaw = val.replace(/[\D]/gi, "")

        if (phoneRaw[0] == '7' || phoneRaw[0] == '8') {
          phoneRaw = phoneRaw.slice(1)
        }

        let phoneInt = phoneRaw.replace(/[\D]/gi, '').split('');
        let phone = '';

        phoneInt.forEach((item, i) => {
          if (i === 0) phone += `+7 (`

          if (i === 3) {
            phone += `) `
          }
          if (i == 6) phone += `-`
          if (i == 8) phone += `-`
          if (i < 10) phone += item
        });

        return phone
      },
    }
  }
</script>
